import React__default, { createContext, useContext, useState, useCallback } from 'react';
import { Loading } from './Loading.es.js';
import { uid } from '../../helpers/utils.es.js';

const LoaderContext = createContext({
  isLoading: () => false,
  setLoading: () => false,
  loaderStateMap: /* @__PURE__ */ new Map(),
  logo: ""
});
const useLoadingContext = () => useContext(LoaderContext);
const LoadingProvider = ({
  children,
  customLoader: CustomLoader,
  logo
}) => {
  const [loaderStateMap, setLoadingStateMap] = useState(/* @__PURE__ */ new Map());
  const isLoading = (id) => {
    return (loaderStateMap.get(id) || 0) > 0;
  };
  const setLoading = useCallback((id, value) => {
    setLoadingStateMap((oldState) => {
      const newState = new Map(oldState);
      let loadingTime = newState.get(id) || 0;
      if (value) {
        loadingTime += 1;
      } else {
        loadingTime -= 1;
      }
      if (loadingTime <= 0) {
        newState.delete(id);
      } else {
        newState.set(id, loadingTime);
      }
      return newState;
    });
  }, [setLoadingStateMap]);
  return /* @__PURE__ */ React__default.createElement(LoaderContext.Provider, {
    value: { isLoading, setLoading, loaderStateMap, logo: logo || "" }
  }, CustomLoader ? /* @__PURE__ */ React__default.createElement(CustomLoader, {
    isLoading: loaderStateMap.size > 0
  }, children) : /* @__PURE__ */ React__default.createElement(Loading, {
    isLoading: loaderStateMap.size > 0
  }, children));
};
function useLoading(prefix = "") {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoading must be inside a LoadingProvider with a state value");
  }
  const [id] = useState(() => prefix ? `${prefix}_${uid()}` : uid());
  const { isLoading, setLoading: setLoadingBase } = context;
  const setLoading = useCallback((state) => {
    return setLoadingBase(id, state);
  }, [id, setLoadingBase]);
  return [isLoading(id), setLoading, id];
}

export { LoadingProvider, useLoading, useLoadingContext };
